export default "__VITE_ASSET__FKsrM65w__"